import styled from "@emotion/styled";

export const TicksBackgroundWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`;

export const TicksWrapper = styled.div`
  display: flex;
  width: 100%;
  user-select: none;
`;

export const TickWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding-top: 0.75rem;
  padding-right: 0.25rem;
  color: #94a3b8;
`;
